/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { IUser } from './services/type';
import type { TRootState } from 'redux/store';

type TAuthState = {
  user: IUser | null;
  token: string | null;
  justLoggedIn: boolean;
};

const slice = createSlice({
  name: 'auth',
  initialState: { user: null, token: null, justLoggedIn: false } as TAuthState,
  reducers: {
    setCredentials: (state, { payload: { user, token } }: PayloadAction<{ user: IUser; token: string }>) => {
      state.user = user;
      state.token = token;
      state.justLoggedIn = true;
    },
    updateUserData: (state, { payload: { user } }: PayloadAction<{ user: IUser }>) => {
      state.user = user;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.justLoggedIn = false;
    },
    updateJustLoggedIn: (state, { payload: { justLoggedIn } }: PayloadAction<{ justLoggedIn: boolean }>) => {
      state.justLoggedIn = justLoggedIn;
    },
  },
});

export const { setCredentials, updateUserData, logout, updateJustLoggedIn } = slice.actions;

export default slice.reducer;

export const selectCurrentUser = (state: TRootState) => state.auth.user;
